import { render, staticRenderFns } from "./SectionData.vue?vue&type=template&id=7547b3ec&scoped=true&"
import script from "./SectionData.vue?vue&type=script&lang=js&"
export * from "./SectionData.vue?vue&type=script&lang=js&"
import style0 from "./SectionData.vue?vue&type=style&index=0&id=7547b3ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547b3ec",
  null
  
)

export default component.exports